import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace } from '@axo/shared/data-access/types';
import { ace_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function';
import { bucketsKeys } from '../../cache-keys/bucketsKeys';
import { useBuckets } from './useBuckets';

export function useWorkQueue(clientID: string, marketCountry: string) {
  const api = useAPI();
  const buckets = useBuckets(marketCountry);

  return useQuery({
    queryKey: [bucketsKeys.workQueue(clientID)],
    queryFn: queryFunction(
      ace_api.findBucketApplications(api),
      ({ queryKey: [{ clientID }] }) => ({
        AssigneeID: clientID,
        Processed: false,
      }),
    ),
    select: (data: ace.FindApplicationBucketRes) =>
      (data?.Items ?? []).sort((a, b) => {
        // Sort by bucket priority first (if buckets are available).
        if ((buckets.data?.length ?? 0) > 0) {
          const priority = (id: string) =>
            buckets.data?.find((bucket) => bucket.ID === id)?.Priority ??
            Infinity;

          const p = priority(a.BucketID) - priority(b.BucketID);
          if (p !== 0) {
            return p;
          }
        }

        // If bucket prio is not available/same for both we sort by bucket
        // updated at. Should be FIFO.
        return a.BucketUpdatedAt < b.BucketUpdatedAt ? -1 : 1;
      }),
    enabled: clientID !== '' && api.token !== '' && !!buckets.data,
  });
}
